<fui-switch-control [disabled]="isReadonly" [label]="label" [attr.id]="elementId" [(ngModel)]="value">
</fui-switch-control>
